import FindReplace from './findReplace'
export default FindReplace
